import { Fragment, memo, useEffect, useState } from 'react';
import ReactMarkDown from 'react-markdown';
import styles from './offer.module.scss';
import { TypingText } from '../typing-text';

function replaceAll(string, search, replace) {
  return string.split(search).join(replace);
}

interface OfferProps {
	text: string;
  markColor?: string;
  dynamicText?: { key: string, value: string[] }[];
}

export const Offer = memo(({ text, markColor, dynamicText }:OfferProps) => {
  const [textArray, setTextArray] = useState([text]);
  useEffect(() => {
    if (dynamicText) {
      let textWithSeparators = String(text);
      dynamicText.forEach(item => {
        textWithSeparators = replaceAll(textWithSeparators, "{{" + item.key + "}}", `|{{${item.key}}}|`)
      });
  
      setTextArray(textWithSeparators.split("|"));
    }
  }, [text, dynamicText]);

	return (<>
    {markColor && <style>{` strong, b { color: ${markColor} !important; } `}</style>}
    <h1 className={styles.offer}>{
      textArray.map(text => {
        const foundDynamicText = dynamicText?.find(item => (text.search(item.key) != -1));
        if (foundDynamicText) return <>{" "}<TypingText key={foundDynamicText.key} options={{ strings: foundDynamicText.value}}/></>;
        return <ReactMarkDown 
        source={text}
        escapeHtml={false}
        key={text}
        renderers={{ 
          paragraph: props => <Fragment children={props.children}/>,
          strong: props => <strong style={{ color: markColor }}>{props.children}</strong>,
          b: props => <b style={{ color: markColor }}>{props.children}</b>
        }}
      /> 
      })
    }
    </h1>
  </>)
});